// eslint-disable-next-line import/prefer-default-export
export const getNewPhoneNumber = (
  state => state.getIn(['settings', 'phoneNumber', 'newPhoneNumber'])
);
